import axios from "axios";
import { useState } from "react";
import { Alert, Button, Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import StarRating from "./StarRating";

const BASE_API_URL = process.env.REACT_APP_API_URL;

const ApplyToDreamCompany = ({
  userId,
  companyName,
  resumeId,
  resumeName,
  questions,
  score,
  onPrevious,
}) => {
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();

  console.log(userId);
  const getStarRating = (score) => {
    const stars = Math.round(score / 2); // convert 10 → 5
    return stars;
  };

  const handleApply = async () => {
    if (!resumeId) {
      setErrorMessage("Please select a resume.");
      return;
    }

    if (!questions.whyApply || !questions.whyDream || !questions.whyFit) {
      setErrorMessage("Please answer all questions.");
      return;
    }

    try {
      Swal.fire({
        title: "Applying...",
        allowOutsideClick: false,
        didOpen: () => Swal.showLoading(),
      });

      const today = new Date().toISOString().split("T")[0];

      const res = await axios.put(
        `${BASE_API_URL}/applyDreamCompanyWithQuestion`,
        null,
        {
          params: {
            userId,
            companyName,
            appliedDate: today,
            resumeId,
            resumeName,
            whyApply: questions.whyApply,
            whyDream: questions.whyDream,
            whyFit: questions.whyFit,
            score:score,
          },
        }
      );

      Swal.close();

      if (res.data) {
        Swal.fire({
          title: "Success",
          text: "Application submitted successfully!",
          icon: "success",
          confirmButtonText: "Go to My Applications",
        }).then(() => {
          navigate("/candidate-dashboard/my-application", {
            state: { userId },
          });
        });
      }
    } catch (error) {
      Swal.close();
      Swal.fire("Error", "Something went wrong. Please try again.", "error");
    }
  };

  return (
    <div className="container py-4">
      <h2 className="mb-4">Review and Submit Your Application</h2>

      {/* 🔹 Preview Card */}
      <Card className="shadow-sm p-4 mb-4">
        <h3>Culture Fit Rating</h3>
        <div className="d-flex align-items-center gap-2">
          <StarRating rating={getStarRating(score)} />
          <h5 className="mt-2">{getStarRating(score)} out of 5 stars</h5>
        </div>

        {errorMessage && <Alert variant="danger">{errorMessage}</Alert>}
        <h4>Company Name: {companyName}</h4>
        {/* <h5>Resume ID: {resumeId}</h5> */}
        <h5>Resume Name: {resumeName}</h5>
        <br />
        <h6>Why do you want to apply to this company?</h6>
        <p>{questions.whyApply}</p>

        <h6>Why do you think this is your dream company?</h6>
        <p>{questions.whyDream}</p>

        <h6>Why are you a good fit for this company?</h6>
        <p>{questions.whyFit}</p>

        {/* <h6 className="mt-3">Value Fit Rating</h6>
        <StarRating rating={getStarRating(score)} />
        <p>{getStarRating(score)} / 5 stars</p> */}
      </Card>

      {/* 🔹 Actions */}
      <div className="d-flex justify-content-between">
        <Button variant="outline-secondary" onClick={onPrevious}>
          Previous
        </Button>

        <Button variant="primary" onClick={handleApply}>
          Submit Application
        </Button>
      </div>
    </div>
  );
};

export default ApplyToDreamCompany;
